import { render, staticRenderFns } from "./LanguageModal.vue?vue&type=template&id=cab6947e&scoped=true"
import script from "./LanguageModal.vue?vue&type=script&lang=js"
export * from "./LanguageModal.vue?vue&type=script&lang=js"
import style0 from "./LanguageModal.vue?vue&type=style&index=0&id=cab6947e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cab6947e",
  null
  
)

export default component.exports